// @flow
/**
 * User: Mike Chung
 * Date: 21/1/2018
 * Time: 12:06 AM
 */


import type {
    PhotoEBadgeBulkDeleteFailedAction,
    PhotoEBadgeBulkDeleteStartAction,
    PhotoEBadgeBulkDeleteSuccessAction,
    PhotoEBadgeDeleteFailedAction,
    PhotoEBadgeDeleteStartAction,
    PhotoEBadgeDeleteSuccessAction,
    TogglePhotoAction
} from "../actions/ebadge/photo/photoEBadgeAction";
import _ from "lodash";
import type {PhotoEBadgeQueryStartAction} from "../actions/ebadge/photo/photoEBadgeQueryAction";


export type PhotoEBadgeActionState = {

    del: {

        [registrationCode: string]: {
            isLoading: boolean
        },
        error?: any,
        bulk: {
            registrationCodes: Array<string>,
            isLoading: boolean,
            error?: any
        }
    }
};

const INITIAL_STATE: PhotoEBadgeActionState = {
    del: {
        bulk: {
            registrationCodes: [],
            isLoading: false
        }
    }
};

type Action = PhotoEBadgeDeleteStartAction
    | PhotoEBadgeDeleteSuccessAction
    | PhotoEBadgeDeleteFailedAction
    | TogglePhotoAction
    | PhotoEBadgeBulkDeleteStartAction
    | PhotoEBadgeBulkDeleteSuccessAction
    | PhotoEBadgeBulkDeleteFailedAction
    | PhotoEBadgeQueryStartAction;

export default function reducer(state: PhotoEBadgeActionState = INITIAL_STATE, action: Action): PhotoEBadgeActionState {

    let result = {
        ...state
    };
    switch (action.type) {
        case "ebadge/photo/DELETE_START_ACTION":
            result.del[action.registrationCode] = {
                isLoading: true
            };
            return result;
        case "ebadge/photo/DELETE_SUCCESS_ACTION":
            result.del[action.registrationCode] = {
                isLoading: false
            };
            return result;
        case "ebadge/photo/DELETE_FAILED_ACTION":
            result.del[action.registrationCode] = {
                isLoading: false
            };
            result.del.error = action.error;
            return result;
        case "ebadge/photo/BULK_DELETE_START_ACTION":
            result.del.bulk.isLoading = true;
            return result;
        case "ebadge/photo/BULK_DELETE_SUCCESS_ACTION":
        case "ebadge/photo/QUERY_START_ACTION":
            result.del.bulk = {
                registrationCodes: [],
                isLoading: false
            };
            return result;
        case "ebadge/photo/BULK_DELETE_FAILED_ACTION":
            result.del.bulk.isLoading = false;
            result.del.bulk.error = action.error;
            return result;
        case "ebadge/photo/TOGGLE_PHOTO":
            const casted: TogglePhotoAction = action;
            if (_.includes(result.del.bulk.registrationCodes, action.registrationCode)) {
                _.remove(result.del.bulk.registrationCodes, (e: string) => e === casted.registrationCode)
            } else {
                result.del.bulk.registrationCodes.push(action.registrationCode);
            }
            return result;
        default:
            return state;
    }

}


// WEBPACK FOOTER //
// ./src/reducers/PhotoEBadgeActionReducer.js